import {Injectable} from '@angular/core';
import {of, ReplaySubject} from 'rxjs';
import {FreeTrialDTO, FreeTrialResponse} from '../models/free-trial.model';
import {CategoryEnum, LoginPayLoad, User, UserAccount} from '../models/account.model';
import {DataService} from './data.service';
import {CrawlerService} from './crawler.service';
import {Feedback, Message} from '../models/feedback.model';

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    private readonly APP_PREFIX = 'smart-assistant';
    private readonly DEVICE_OS = 'Other';
    private readonly GRANT_TYPE = 'password';
    private readonly LOGIN_DOMAIN = 'bueroservice24.de';
    private readonly VISITOR_ID = '1234567';
    private _greetingSaved$ = new ReplaySubject<boolean>(1);
    private _openCategory$ = new ReplaySubject<CategoryEnum>(1);
    private _testCallReady$ = new ReplaySubject<boolean>(1);
    private _user: User | undefined;
    private _user$ = new ReplaySubject<User>(1);
    private _userAccount$ = new ReplaySubject<UserAccount>(1);
    public greetingSaved$ = this._greetingSaved$.asObservable();
    public openCategory$ = this._openCategory$.asObservable();
    public testCallReady$ = this._userAccount$.asObservable();
    public user$ = this._user$.asObservable();
    public userAccount$ = this._userAccount$.asObservable();
    
    constructor(private dataService: DataService,
                private crawlerService: CrawlerService) {
    }
    
    public get user(): User {
        return JSON.parse(JSON.stringify(this._user));
    }
    
    private get userAccount(): UserAccount {
        return JSON.parse(JSON.stringify(this._user?.userAccount));
    }
    
    public generateAccountName() {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        let randomString = '';
        for (let i = 0; i < 30; i++) {
            const randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz, randomPoz + 1);
        }
        return randomString;
    }
    
    public login(freeTrialDTO: FreeTrialDTO, email: string, freeTrialResponse?: FreeTrialResponse) {
        console.log('login', freeTrialDTO, freeTrialResponse);
        this._user = new User(freeTrialDTO);
        // TODO save email!
        
        const loginPayLoad: LoginPayLoad = {
            username: freeTrialDTO.first_name,
            password: freeTrialDTO.password,
            domain: 'https://' + this.LOGIN_DOMAIN,
            grant_type: this.GRANT_TYPE,
            device_id: this.VISITOR_ID,
            device_os: this.DEVICE_OS,
            app_name: this.APP_PREFIX + this.LOGIN_DOMAIN,
        };
        
        this.dataService.login(loginPayLoad).subscribe((res) => {
            this.dataService.checkToken().subscribe((res) => {
                
                this._user?.setBaseData(res);
                console.log('--------', this._user, res);
                if (!this._user || !this._user.baseData?.website || !this._user.phoneService?.phoneServiceId || !this?._user.userAccount?.email) {
                    return;
                }
                this._user.userAccount.email = email;
                this.createNotificationTargets(email, res?.details?.login);
                this._userAccount$.next(this.userAccount);
                this._user$.next(this.user);
            });
        });
    }
    
    public openCategory(category: CategoryEnum) {
        this._openCategory$.next(category);
    }
    
    public saveGreeting(greeting: string) {
        if (!this._user?.phoneService?.phoneServiceId) {
            return;
        }
        this.dataService.saveGreeting(greeting, this._user.phoneService.phoneServiceId).subscribe((res) => {
            this._greetingSaved$.next(true);
        });
        
    }
    
    
    sendFeedbackRequest$(feedback: Feedback) {
        if (!this._user || !this._user.isValid()) {
            console.error('No user account id available.');
            return of();
            
        }
        const userCoreData = this._user.coreData();
        const preMsg = `type of feedback: *PORTAL:OTHER: AI-test\n`;
        const msg : Message =  {
            brandId: userCoreData.brandId,
            concernId: 55,
            concernType: 'PORTAL',
            customerId: +userCoreData.customerId,
            languageId: +userCoreData.languageId,
            messageContent: preMsg.concat(feedback.getSendData()),
            phoneServiceId: +userCoreData.phoneServiceId,
            userAccountId: userCoreData.userAccountId
            
        };
        
        return this.dataService.sendContactRequest(msg, userCoreData.userAccountId);
    }
    
    private createNotificationTargets(email: string, existingTarget?: string) {
        if (!this._user || !this._user?.userAccount?.userAccountId || !this._user?.phoneService?.phoneServiceId) {
            return;
        }
        const uaId = this._user.userAccount.userAccountId;
        const psId = this._user.phoneService.phoneServiceId;
        this.dataService.createEmailNotification$(email, uaId, psId).subscribe((res) => {
            console.log(res);
            this.dataService.fetchNotificationTargets$(psId).subscribe((notificationRes) => {
                console.log(notificationRes);
                if (!!existingTarget) {
                    const notification = notificationRes._embedded.notificationDataList.find(elem => elem.reachability.destination === existingTarget);
                    if (!!notification) {
                        this.dataService.deleteNotificationTargets(psId, notification.notificationId);
                    }
                }
                if (!this._user) {
                    return;
                }
                this._user.reachabilities = notificationRes?._embedded?.notificationDataList.filter(notElem => notElem.reachability.destination !== existingTarget);
            });
        });
        
    }
}

